import { isEmpty, isNull, remove } from "lodash";
const initialState = {
  //FORMS SERVED SPOUSE
  getFormsServedSpouse: [],
  getFormsPetitionPacket: [],

  //INITIAL STATES

  //PETITIONER CHECK

  isPetitioner: "-1",

  //PETITIONER_PACKET_FILLED_CHECK

  isFilledPetitionerPacket: "-1",

  //CASE_NUMBER

  caseNo: "",

  //SPOUSE_SERVED_WITH_PETITION_PACKET_CHECK

  isSpouseServedWithPetitionPacket: "-1",

  //HOW_PETITION_PACKET_SERVED

  howPetitionPacketServed: {
    defaultSelected: "-1",
    personalService: {
      serverServedPetitionPacketDate: "",
      serverServedPetitionPacketTime: "",
      serverServedPetitionAddress: "",
    },
    substitutedService: {
      petitionPacketReceiverName: "",
      petitionPacketReceiverRelationship: "",
      petitionPacketReceivingPlace: "",
      petitionPacketReceivingDate: "",
      petitionPacketReceivingTime: "",
      petitionPacketCopyMailedDate: "",
      petitionPacketCopyAddress: "",
    },
    serverMailed: {
      dateServerMailed: "",
      mailedFromCity: "",
      mailOutsideCalifornia: "",
      serverAddress: "",
    },
    other: {
      otherInput: "",
    },
  },

  //SERVER_DETAILS

  serverDetails: {
    serverName: "",
    serverAddress: "",
    serverPhoneNumber: "",
  },

  //POST_OF_SERVER

  postOfServer: "3",

  //SERVER_REGISTRATION

  serverRegistration: {
    no: {
      isServerCaliforniaRegistered: "-1",
    },
    yes: {
      serverType: "-1",

      registrationNo: "",
      country: "",
      servingFee: "",
    },
  },

  //SERVER_MARSHAL_CONSTABLE

  isServerCaliforniaSheriffConstable: "-1",

  //PETITION_PACKET_VIA_MAIL
  isPetitionPacketViaMail: "-1",

  //MAIL_BY_POST
  isMailByPost: "-1",

  //MAIL_CARRIER

  isMailCarrier: "-1",

  //WHO_MAILED_DOCUMENTS

  documentsMailerName: "",

  //WHERE_DOCUMENTS_MAILER_LIVE
  documentsMailerLive: "",

  //ADDRESS_ DOCUMENTS_MAILED
  documentsMailedAddress: "",

  //DOCUMENTS_MAILED_DATE

  documentsMailedDate: "",

  //DOCUMENTS_MAILED_FROM

  documentsMailedFrom: "",

  isFetchingCourtFormData: false,
  isFetchingFormsServedSpouse: false,
  isFetchingDocumentsServedSpouse: false,
  isFetchingHowPetitionPacketServed: false,
  isFetchingRegisteredCaliforniaServer: false,
  isFetchingDocumentsMailedCityState: false,
  isFetchingDateDocumentsMailed: false,
  isFetchingDocumentsMailedAddress: false,
  isFetchingServerAddress: false,
  isFetchingMailCarrier: false,
  isFetchingMailedFromPostOffice: false,
  isFetchingResponsePacketByMail: false,
  isFetchingCaliforniaSheriffMarshalConstable: false,
  isFetchingPostOfPersonServedSpouse: false,
  isFecthingForms: false,
  isFetchingStartServingCourt: false,
  isFetchingPutPetitioner: false,
  isFetchingFilledPetitionPacket: false,
  isFetchingCaseNumber: false,
  isFetchingPetitionServedStatus: false,
  isFetchingServerDetails: false,
  isFetchingFormsPetitionPacket: false,
  selectedServedForms:[],
  servedOtherFormsSpecify : "",
  selectedPetitionForms: [],
  otherSelectedPetitionFormsSpecify : ""
};

const servingCourtReducer = (state = initialState, action) => {
  switch (action.type) {
    //GET FORM DATA
    case "REQUEST_COURT_FORM_DATA":
      return { ...state, isFetchingCourtFormData: true };
    case "SUCCESS_COURT_FORM_DATA":
       
      return isEmpty(action.payload.data) ? state:{
        ...state,
        isFetchingCourtFormData: false,
        selectedServedForms : action.payload.data.selectedServedForms,
        selectedPetitionForms  : action.payload.data.selectedPetitionForms,
        otherSelectedPetitionFormsSpecify : action.payload.data.otherSelectedPetitionFormsSpecify,
        isPetitioner: action.payload.data.isPetitioner,
        isFilledPetitionerPacket: action.payload.data.isFilledPetitionerPacket,
        caseNo: action.payload.data.caseNo,
        isSpouseServedWithPetitionPacket:
          action.payload.data.isSpouseServedWithPetitionPacket,
        howPetitionPacketServed: {
          defaultSelected: action.payload.data.howPetitionPacketServed.defaultSelected,
          personalService: {
            serverServedPetitionPacketDate:
              action.payload.data.howPetitionPacketServed.personalService
                .serverServedPetitionPacketDate,
            serverServedPetitionPacketTime:
              action.payload.data.howPetitionPacketServed.personalService
                .serverServedPetitionPacketTime,
            serverServedPetitionAddress: 
              action.payload.data.howPetitionPacketServed.personalService
            .serverServedPetitionAddress,
          },
          substitutedService: {
            petitionPacketReceiverName:
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketReceiverName,
            petitionPacketReceiverRelationship:
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketReceiverRelationship,
            petitionPacketReceivingPlace:
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketReceivingPlace,
            petitionPacketReceivingDate:
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketReceivingDate,
            petitionPacketReceivingTime:
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketReceivingTime,
            petitionPacketCopyMailedDate:
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketCopyMailedDate,

                petitionPacketCopyAddress: 
              action.payload.data.howPetitionPacketServed.substitutedService
                .petitionPacketCopyAddress,
          },
          serverMailed: {
            dateServerMailed:
              action.payload.data.howPetitionPacketServed.serverMailed
                .dateServerMailed,
            mailedFromCity:
              action.payload.data.howPetitionPacketServed.serverMailed
                .mailedFromCity,
            mailOutsideCalifornia:
              action.payload.data.howPetitionPacketServed.serverMailed
                .mailOutsideCalifornia,
            serverAddress:action.payload.data.howPetitionPacketServed.serverMailed
            .serverAddress,
          },
          other: {
            otherInput:
              action.payload.data.howPetitionPacketServed.other.otherInput,
          },
        },
        serverDetails: {
          serverName: action.payload.data.serverDetails.serverName,
          serverAddress: action.payload.data.serverDetails.serverAddress,
          serverPhoneNumber:
            action.payload.data.serverDetails.serverPhoneNumber,
        },

        postOfServer: action.payload.data.postOfServer,
        
        serverRegistration: {
          no: {
            isServerCaliforniaRegistered:
              action.payload.data.serverRegistration.no
                .isServerCaliforniaRegistered,
          },
          yes: {
            serverType: action.payload.data.serverRegistration.yes.serverType,
            registrationNo:
              action.payload.data.serverRegistration.yes.registrationNo,
            country: action.payload.data.serverRegistration.yes.country,
            servingFee: action.payload.data.serverRegistration.yes.servingFee,
          },
        },
        isServerCaliforniaSheriffConstable:
          action.payload.data.isServerCaliforniaSheriffConstable,
        isPetitionPacketViaMail: action.payload.data.isPetitionPacketViaMail,
        isMailByPost: action.payload.data.isMailByPost,
        isMailCarrier: action.payload.data.isMailCarrier,
        documentsMailerName: action.payload.data.documentsMailerName,
        documentsMailerLive: action.payload.data.documentsMailerLive,
        documentsMailedAddress: action.payload.data.documentsMailedAddress,
        documentsMailedDate: action.payload.data.documentsMailedDate,
        documentsMailedFrom: action.payload.data.documentsMailedFrom,
      };
    case "ERROR_COURT_FORM_DATA":
      return { ...state, isFetchingCourtFormData: false };

    //FORMS PETITION PACKET
    case "REQUEST_FORMS_PETITION_PACKET":
      return { ...state, isFetchingFormsPetitionPacket: true };
    case "SUCCESS_FORMS_PETITION_PACKET":
      return {
        ...state,
        isFetchingFormsPetitionPacket: false,
        getFormsPetitionPacket: action.payload,
      };
    case "ERROR_FORMS_PETITION_PACKET":
      return { ...state, isFetchingFormsPetitionPacket: false };

    //FORMS SERVED SPOUSE

    case "REQUEST_FORMS_SERVED_SPOUSE":
      return { ...state, isFetchingFormsPetitionPacket: true };
    case "SUCCESS_FORMS_SERVED_SPOUSE":
      return {
        ...state,
        isFetchingFormsServedSpouse: false,
        getFormsServedSpouse: action.payload,
      };
    case "ERROR_FORMS_SERVED_SPOUSE":
      return { ...state, isFetchingFormsServedSpouse: false };
    //HOW PETITION PACKET SERVED

    //DocumentsServedSpouse

    case "REQUEST_DOCUMENTS_SERVED_SPOUSE":
      return { ...state, isFetchingDocumentsServedSpouse: true };
    case "SUCCESS_DOCUMENTS_SERVED_SPOUSE":
      return {
        ...state,
        isFetchingDocumentsServedSpouse: false,
        selectedServedForms: action.payload.documentServeSpouse,
        servedOtherFormsSpecify : action.payload.servedOtherFormSpcify,

      };
    case "ERROR_DOCUMENTS_SERVED_SPOUSE":
      return { ...state, isFetchingDocumentsServedSpouse: false };
    //HOW PETITION PACKET SERVED

    case "REQUEST_HOW_PETITION_PACKET_SERVED":
      return { ...state, isFetchingHowPetitionPacketServed: true };
    case "SUCCESS_HOW_PETITION_PACKET_SERVED":
      return { ...state,
        howPetitionPacketServed: {
          defaultSelected: action.payload.howSpouseServed,
          personalService: {
            serverServedPetitionPacketDate: action.payload.serverServedPetitionDate,
            serverServedPetitionPacketTime: action.payload.serverServedPetitionTime,
            serverServedPetitionAddress: action.payload.personalServiceAddress,
          },
          substitutedService: {
            petitionPacketReceiverName: action.payload.petitionPacketReceiverName,
            petitionPacketReceiverRelationship:action.payload.petitionPacketReceiverRelationship,
            petitionPacketReceivingPlace: action.payload.petitionPacketReceivingPlace,
            petitionPacketReceivingDate: action.payload.petitionPacketReceivingDate,
            petitionPacketReceivingTime: action.payload.petitionPacketReceivingTime,
            petitionPacketCopyMailedDate: action.payload.petitionPacketCopyMailedDate,
            petitionPacketCopyAddress: action.payload.substitudeServiceAddress,
          },
          serverMailed: {
            dateServerMailed: action.payload.dateServerMailed,
            mailedFromCity:action.payload.mailedFromCity,
            mailOutsideCalifornia: action.payload.mailedOutOfCalifornia,
            serverAddress:action.payload.addressToMail,
          },
          other: {
            otherInput: action.payload.servedPetitionPacketInOtherWay,
          },
        },  
        isFetchingHowPetitionPacketServed: false 
      };
    case "ERROR_HOW_PETITION_PACKET_SERVED":
      return { ...state, isFetchingHowPetitionPacketServed: false };

    //REGISTERED CALIFORNIA SERVER

    case "REQUEST_REGISTERED_CALIFORNIA_SERVER":
      return { ...state, isFetchingRegisteredCaliforniaServer: true };
    case "SUCCESS_REGISTERED_CALIFORNIA_SERVER":
      return {
        ...state,
        isFetchingRegisteredCaliforniaServer: false,
        serverRegistration: {
          no: {
            isServerCaliforniaRegistered: action.payload.registeredCalifornia,
          },
          yes: {
            serverType: action.payload.serverType,
            registrationNo: action.payload.registrationNo,
            country: action.payload.serverCountry,
            servingFee: action.payload.feeForServing,
          },
        },
        
      };
    case "ERROR_REGISTERED_CALIFORNIA_SERVER":
      return { ...state, isFetchingRegisteredCaliforniaServer: false };

    //DOCUMENTS MAILED CITY STATE

    case "REQUEST_DOCUMENTS_MAILED_CITY_STATE":
      return { ...state, isFetchingDocumentsMailedCityState: true };
    case "SUCCESS_DOCUMENTS_MAILED_CITY_STATE":
      return {
        ...state,
        isFetchingDocumentsMailedCityState: false,
        documentsMailedFrom: action.payload.serverMailDocumentCity,
      };
    case "ERROR_DOCUMENTS_MAILED_CITY_STATE":
      return { ...state, isFetchingDocumentsMailedCityState: false };

    //DATE DOCUMENTS MAILED

    case "REQUEST_DATE_DOCUMENTS_MAILED":
      return { ...state, isFetchingDateDocumentsMailed: true };
    case "SUCCESS_DATE_DOCUMENTS_MAILED":
      return {
        ...state,
        isFetchingDateDocumentsMailed: false,
        documentsMailedDate: action.payload.serverMailDocumentDate,
      };
    case "ERROR_DATE_DOCUMENTS_MAILED":
      return { ...state, isFetchingDateDocumentsMailed: false };

    //DOCUMENT MAILED ADDRESS

    case "REQUEST_DOCUMENTS_MAILED_ADDRESS":
      return { ...state, isFetchingDocumentsMailedAddress: true };
    case "SUCCESS_DOCUMENTS_MAILED_ADDRESS":
      return {
        ...state,
        isFetchingDocumentsMailedAddress: false,
        documentsMailedAddress: action.payload.serverMailDocumentAddress,
      };
    case "ERROR_DOCUMENTS_MAILED_ADDRESS":
      return { ...state, isFetchingDocumentsMailedAddress: false };

    
     //SERVER NAME
      case "REQUEST_SERVER_NAME":
        return { ...state, isFetchingServerName: true };
      case "SUCCESS_SERVER_NAME":
        return {
          ...state,
          isFetchingServerName: false,
          documentsMailerName: action.payload.serverName,
        };
      case "ERROR_SERVER_NAME":
        return { ...state, isFetchingServerName: false };
     
        //SERVER ADDRESS

    case "REQUEST_SERVER_ADDRESS":
      return { ...state, isFetchingServerAddress: true };
    case "SUCCESS_SERVER_ADDRESS":
      return {
        ...state,
        isFetchingServerAddress: false,
        documentsMailerLive: action.payload.serverAddress,
      };
    case "ERROR_SERVER_ADDRESS":
      return { ...state, isFetchingServerAddress: false };

    //MAIL CARRIER

    case "REQUEST_MAIL_CARRIER":
      return { ...state, isFetchingMailCarrier: true };
    case "SUCCESS_MAIL_CARRIER":
      return {
        ...state,
        isFetchingMailCarrier: false,
        isMailCarrier: action.payload.mailCarrier,
      };
    case "ERROR_MAIL_CARRIER":
      return { ...state, isFetchingMailCarrier: false };

    //MAILED FROM POST OFFICE

    case "REQUEST_MAILED_FROM_POST_OFFICE":
      return { ...state, isFetchingMailedFromPostOffice: true };
    case "SUCCESS_MAILED_FROM_POST_OFFICE":
      return {
        ...state,
        isFetchingMailedFromPostOffice: false,
        isMailByPost: action.payload.mailPostOffice,
      };
    case "ERROR_MAILED_FROM_POST_OFFICE":
      return { ...state, isFetchingMailedFromPostOffice: false };

    //RESPONSE PACKET BY MAIL

    case "REQUEST_RESPONSE_PACKET_BY_MAIL":
      return { ...state, isFetchingResponsePacketByMail: true };
    case "SUCCESS_RESPONSE_PACKET_BY_MAIL":
      return {
        ...state,
        isFetchingResponsePacketByMail: false,
        isPetitionPacketViaMail: action.payload.servedResponsePacket,
      };
    case "ERROR_RESPONSE_PACKET_BY_MAIL":
      return { ...state, isFetchingResponsePacketByMail: false };

    //CaliforniaSheriffMarshalConstable
    case "REQUEST_CALIFORNIA-SHERIFF_MARSHAL_CONSTABLE":
      return { ...state, isFetchingCaliforniaSheriffMarshalConstable: true };
    case "SUCCESS_CALIFORNIA-SHERIFF_MARSHAL_CONSTABLE":
      return {
        ...state,
        isFetchingCaliforniaSheriffMarshalConstable: false,
        isServerCaliforniaSheriffConstable: action.payload.serverConstable,
      };
    case "ERROR_CALIFORNIA-SHERIFF_MARSHAL_CONSTABLE":
      return { ...state, isFetchingCaliforniaSheriffMarshalConstable: false };

    //postOfPersonServedSpouse

    case "REQUEST_PERSON_SERVED":
      return { ...state, isFetchingPostOfPersonServedSpouse: true };
    case "SUCCESS_PERSON_SERVED":
      return {
        ...state,
        isFetchingPostOfPersonServedSpouse: false,
        postOfServer: action.payload.personServedSpouse,
      };
    case "ERROR_PERSON_SERVED":
      return { ...state, isFetchingPostOfPersonServedSpouse: false };

    //SERVER DETAILS

    case "REQUEST_SERVER_DETAILS":
      return { ...state, isFetchingServerDetails: true };
    case "SUCCESS_SERVER_DETAILS":
      return {
        ...state,
        isFetchingServerDetails: false,
        serverDetails: {
          serverName: action.payload.spouseServerName,
          serverAddress: action.payload.spouseServerAddress,
          serverPhoneNumber: action.payload.spouseServerPhone,
        },
      };
    case "ERROR_SERVER_DETAILS":
      return { ...state, isFetchingServerDetails: false };

    //INCLUDING FORMS
    case "REQUEST_INCLUDING_FORMS":
      return { ...state, isFecthingForms: true };
    case "SUCCESS_INCLUDING_FORMS":
      return { 
        ...state, 
        selectedPetitionForms: action.payload.formsPetitionalPacket,
        otherSelectedPetitionFormsSpecify :  action.payload.other,

        isFecthingForms: false };
    case "ERROR_INCLUDING_FORMS":
      return { ...state, isFecthingForms: false };

    //PETITION PACKET SERVED

    case "REQUEST_SERVED_PETITION_PACKET":
      return { ...state, isFetchingPetitionServedStatus: true };
    case "SUCCESS_SERVED_PETITION_PACKET":
      return {
        ...state,
        isFetchingPetitionServedStatus: false,
        isSpouseServedWithPetitionPacket: action.payload.petitionServedPacket,
      };
    case "ERROR_SERVED_PETITION_PACKET":
      return { ...state, isFetchingPetitionServedStatus: false };

    //CASE NUMBER
    case "REQUEST_CASE_NUMBER":
      return { ...state, isFetchingCaseNumber: true };
    case "SUCCESS_CASE_NUMBER":
      return {
        ...state,
        isFetchingCaseNumber: false,
        caseNo: action.payload.caseNumber,
      };
    case "ERROR_CASE_NUMBER":
      return { ...state, isFetchingCaseNumber: false };

    //FilledPetitionPacket
    case "REQUEST_FILLED_PETITION_PACKET":
      return { ...state, isFetchingFilledPetitionPacket: true };
    case "SUCCESS_FILLED_PETITION_PACKET":
      return {
        ...state,
        isFetchingFilledPetitionPacket: false,
        isFilledPetitionerPacket: action.payload.filedPetition,
      };
    case "ERROR_FILLED_PETITION_PACKET":
      return { ...state, isFetchingFilledPetitionPacket: false };

    //Start Serving Court
    case "REQUEST_START_SERVING_COURT":
      return { ...state, isFetchingStartServingCourt: true };
    case "SUCCESS_START_SERVING_COURT":
      return {
        ...state,
        isFetchingStartServingCourt: false,
      };
    case "ERROR_START_SERVING_COURT":
      return { ...state, isFetchingStartServingCourt: false };

    //PutPetitioner
    case "REQUEST_PUT_PETITIONER":
      return { ...state, isFetchingPutPetitioner: true };
    case "SUCCESS_PUT_PETITIONER":
      return {
        ...state,
        isFetchingPutPetitioner: false,
        isPetitioner: action.payload.petitioner,
      };
    case "ERROR_PUT_PETITIONER":
      return { ...state, isFetchingPutPetitioner: false };

    default:
      return state;
  }
};

export default servingCourtReducer;
